/** @module Actions */
import {
  ADD_TAG,
  ADD_TAG_WITH_VALUES,
  ADD_CREATED_TAG,
  EDIT_TAG,
  DELETE_TAG,
  CHANGE_TAG_COLOR,
  LOAD_TAGS,
  DUPLICATE_TAG,
} from '../constants/ActionTypes'

/**
 * @typedef {import('../index').Tag} Tag
 */

/**
 * @typedef {ReturnType<typeof addTag> | ReturnType<typeof addTagWithValues> | ReturnType<typeof addCreatedTag> | ReturnType<typeof editTag> | ReturnType<typeof changeColor> | ReturnType<typeof deleteTag> | ReturnType<typeof load> | ReturnType<typeof duplicateTag>} TagsActions
 */

/**
 * Adds a tag
 * @return {{ type: 'ADD_TAG' }}
 */
export function addTag() {
  return { type: ADD_TAG }
}

/**
 * Adds a tag with values
 * @param {string} title the title of the tag
 * @param {string} color the color of the tag (either a hex value or a color name)
 * @return {{ type: 'ADD_TAG_WITH_VALUES', title: String, color: String }}
 */
export function addTagWithValues(title, color) {
  return {
    type: ADD_TAG_WITH_VALUES,
    title,
    color,
  }
}

/**
 * Adds a tag from an object
 * @param {Partial<Tag>} attributes all the attributes of a tag
 * @return {{ type: 'ADD_CREATED_TAG', attributes: Partial<Tag> }}
 */
export function addCreatedTag(attributes) {
  return { type: ADD_CREATED_TAG, attributes }
}

/**
 * Edits a tag
 * @param {number} id the tag's id
 * @param {string} title the tag's title
 * @param {string} color the tag's color
 * @param {number | null} categoryId the tag's category id
 * @return {{ type: 'EDIT_TAG', id: number, title: String, color: String, categoryId: number | Null }}
 */
export function editTag(id, title, color, categoryId) {
  return { type: EDIT_TAG, id, title, color, categoryId: categoryId || null }
}

/**
 * Changes a tag's color
 * @param {number} id the tag's id
 * @param {string} color the tag's new color
 * @return {{ type: 'CHANGE_TAG_COLOR', id: number, color: String }}
 */
export function changeColor(id, color) {
  return { type: CHANGE_TAG_COLOR, id, color }
}

/**
 * Deletes a tag
 * @param {number} id the tag's id
 * @return {{ type: 'DELETE_TAG', id: number }}
 */
export function deleteTag(id) {
  return { type: DELETE_TAG, id }
}

// NOTE: "load", "loadSingle", "batchLoad" and "removeSingle" are for
// external sync and not for general use.
/**
 * @param {boolean} patching
 * @param {Array<Tag>} tags array of tag objects
 * @return {{ type: 'LOAD_TAGS', patching: boolean, tags: Array<Tag> }}
 */
export function load(patching, tags) {
  return { type: LOAD_TAGS, patching, tags }
}

/**
 * Duplicates a tag
 * @param {number} id the id of the tag to duplicate
 * @return {{ type: 'DUPLICATE_TAG', id: number }}
 */
export function duplicateTag(id) {
  return { type: DUPLICATE_TAG, id }
}
